import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { GridRow, GridColumn, Utils } from "arv-reactcomponents";
import {
  PDP_CAROUSEL_HEADINGS,
  STORAGE_KEYS,
  PDP_CAROUSEL_MAX_LIMIT,
} from "../../../constants";
import ProductCarousel from "../../ProductCarousel";

@inject("ProductStore")
@observer
class PdpBottomCarousels extends Component {
  constructor() {
    super();
    this.state = {
      recentlyViewedStyles: [],
      inThisLook: [],
      similarProducts: [],
    };
    this.styleId = null;
    this.secondaryStyleIds = [];
    this.isUserLoggedIn = false;
    this.initRecentlyViewedStyles = this.initRecentlyViewedStyles.bind(this);
    this.clearRecentlyViewed = this.clearRecentlyViewed.bind(this);
    this.initThisLook = this.initThisLook.bind(this);
    this.initSimilarProducts = this.initSimilarProducts.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.styleId !== this.styleId) {
      this.initSimilarProducts(nextProps.styleId);
    }
    if (
      nextProps.styleId !== this.styleId ||
      (nextProps.isUserLoggedIn !== this.isUserLoggedIn &&
        nextProps.isUserLoggedIn)
    ) {
      this.initRecentlyViewedStyles(
        nextProps.styleId,
        nextProps.isUserLoggedIn,
      );
    }
    if (
      nextProps.secondaryStyleIds &&
      nextProps.secondaryStyleIds.length > 0 &&
      nextProps.secondaryStyleIds !== this.secondaryStyleIds
    ) {
      this.initThisLook(nextProps.secondaryStyleIds);
    }
    if (
      !nextProps.isUserLoggedIn &&
      nextProps.isUserLoggedIn !== this.isUserLoggedIn
    ) {
      this.clearRecentlyViewed();
    }
    this.isUserLoggedIn = nextProps.isUserLoggedIn;
    this.styleId = nextProps.styleId;
    this.secondaryStyleIds = nextProps.secondaryStyleIds;
  }
  get similarProductsUrl() {
    const newUrl =
      this.state.similarProducts.length >= PDP_CAROUSEL_MAX_LIMIT
        ? `/products?style=${this.styleId}&cid=CUSTOM_SIMILAR_PRODUCTS`
        : "";
    return newUrl;
  }
  initSimilarProducts(styleId) {
    const { ProductStore } = this.props;
    const reqBody = JSON.stringify({
      module: "odin",
      styleId,
    });
    ProductStore.similarProducts(reqBody).then(data => {
      this.setState({ similarProducts: data });
    });
  }
  initRecentlyViewedStyles(styleId, isUserLoggedIn) {
    const { ProductStore } = this.props;
    const styles = Utils.localStorage.getItem(STORAGE_KEYS.RECENTLY_VIEWED);
    const currentStyle = [styleId];
    const newSet = styles
      ? new Set([...currentStyle, ...styles])
      : new Set([...currentStyle]);
    let newArray = [...newSet];
    newArray = newArray.slice(0, PDP_CAROUSEL_MAX_LIMIT);
    if (!isUserLoggedIn) {
      Utils.localStorage.setItem(STORAGE_KEYS.RECENTLY_VIEWED, newArray);
    } else {
      Utils.localStorage.removeItem(STORAGE_KEYS.RECENTLY_VIEWED);
    }
    const reqBody = JSON.stringify({ styles: newArray });
    ProductStore.getRecentlyViewedStyles(reqBody, isUserLoggedIn).then(data => {
      const filteredData =
        (data &&
          data.length > 0 &&
          data.filter(item => item.styleId !== styleId)) ||
        [];
      this.setState({ recentlyViewedStyles: filteredData });
    });
  }
  clearRecentlyViewed() {
    this.setState({ recentlyViewedStyles: [] });
  }
  initThisLook(styleArray) {
    const { ProductStore } = this.props;
    const reqBody = JSON.stringify(styleArray);
    ProductStore.inThisLook(reqBody).then(data => {
      this.setState({ inThisLook: data });
    });
  }

  render() {
    const { recentlyViewedStyles, inThisLook, similarProducts } = this.state;
    return (
      <Fragment>
        <GridRow className="nw-pdp-carouselcontainer nw-pdp">
          <GridColumn>
            <ProductCarousel
              title={PDP_CAROUSEL_HEADINGS.IN_THIS_LOOK}
              list={inThisLook}
              viewAllLink=""
              origin={PDP_CAROUSEL_HEADINGS.IN_THIS_LOOK}
            />
          </GridColumn>
        </GridRow>
        <GridRow className="nw-pdp-carouselcontainer nw-pdp">
          <GridColumn>
            <ProductCarousel
              title={PDP_CAROUSEL_HEADINGS.SIMILAR_PRODUCTS}
              list={similarProducts}
              viewAllLink={this.similarProductsUrl}
              origin={PDP_CAROUSEL_HEADINGS.SIMILAR_PRODUCTS}
            />
          </GridColumn>
        </GridRow>
        <GridRow className="nw-pdp-carouselcontainer nw-pdp">
          <GridColumn>
            <ProductCarousel
              title={PDP_CAROUSEL_HEADINGS.RECENTLY_VIEWED}
              list={recentlyViewedStyles}
              viewAllLink=""
              origin={PDP_CAROUSEL_HEADINGS.RECENTLY_VIEWED}
            />
          </GridColumn>
        </GridRow>
      </Fragment>
    );
  }
}

PdpBottomCarousels.defaultProps = {
  secondaryStyleIds: [],
};

PdpBottomCarousels.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({}).isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  styleId: PropTypes.string.isRequired,
  secondaryStyleIds: PropTypes.arrayOf(PropTypes.string),
};

export default PdpBottomCarousels;



// WEBPACK FOOTER //
// ./src/component/PdpComponents/PdpBottomCarousels/index.js